// FILE: src/pages/Privacy/Privacy.jsx
import React from "react";

export default function Privacy() {
  return (
    <main className="section">
      <div className="container">
        <h1 className="fw-bold text-ink mb-3">Privacy Policy</h1>
        <p className="text-muted-2">
          We respect your privacy. This Policy explains what information we collect, how we use it,
          and your choices. We collect only what's necessary to operate and improve our site and services.
        </p>
        <h5 className="mt-4 text-ink">Data We Collect</h5>
        <p className="text-muted-2">
          Basic contact details you share with us (e.g., email) and usage data to improve
          performance and reliability.
        </p>
        <h5 className="mt-4 text-ink">How We Use Data</h5>
        <p className="text-muted-2">
          To respond to inquiries, operate our services, and enhance user experience. We do not sell your data.
        </p>
        <h5 className="mt-4 text-ink">Your Choices</h5>
        <p className="text-muted-2">
          Contact us to access, update, or delete your information subject to legal obligations.
        </p>
      </div>
    </main>
  );
}
